import axios from 'axios';

export const fetchOverviewAnalytics = async (params = {}) => {
  const response = await axios.get('/api/analytics/overview', { params });
  return response.data.overview;
};

export const fetchBrandAnalytics = async (brandId) => {
  const response = await axios.get(`/api/analytics/brands/${brandId}`);
  return response.data.analytics;
};
